export let GridVariants = /*#__PURE__*/function (GridVariants) {
  GridVariants["Stack"] = "stack";
  GridVariants["Queue"] = "queue";
  GridVariants["Lite"] = "lite";
  return GridVariants;
}({});
export let TilesDataFormat = /*#__PURE__*/function (TilesDataFormat) {
  TilesDataFormat["Content"] = "content";
  TilesDataFormat["Listing"] = "listing";
  return TilesDataFormat;
}({});